import compose from "lodash/fp/compose"

export type MaybeString = string | null | undefined
export const isRequiredMessageKey = "field.isRequired"
const requiredString = (maybeString: MaybeString): boolean =>
  !!maybeString && !!maybeString.trim()
const requiredNumber = (maybeString: MaybeString): boolean =>
  !!maybeString && Number(maybeString) >= 0
const requiredMsg = (y: boolean): string | undefined =>
  y ? undefined : isRequiredMessageKey
export const validateString = compose(requiredMsg, requiredString)
export const validateNumber = compose(requiredMsg, requiredNumber)
